/** Field labels for the file metadata KeyValuePairs. */
export const FILE_DETAIL_LABELS = {
  fileType: 'File Type',
  direction: 'Direction',
  bank: 'Bank',
  dataSource: 'Data Source',
  createdAt: 'Created',
  updatedAt: 'Updated',
  totalE2E: 'Total E2E Latency',
  paymentCount: 'Payment Count',
} as const;
